import { ListCommunityInfoQuery, useListCommunityInfoQuery } from 'src/graphql';
import React, { useEffect, useState } from 'react';

import { BaseBanner } from 'src/components/BaseBanner';
import { BaseSearch } from 'src/components/BaseSearch';
import { LoadingWrapper } from 'src/components/LoadingWrapper';
import { LocationSearch } from 'src/components/LocationSearch';
import { MapSidebarList } from 'src/components/MapSidebar/components/MapSidebarCommunitiesList';
import { TMyCommunitiesProps } from './MyCommunities.types';
import s from './MyCommunities.module.scss';
import { selectCommunitiesList } from 'src/redux/communities/communities.selectors';
import { selectTokenAuth } from 'src/redux/auth/auth.selectors';
import { setCommunitiesList } from 'src/redux/communities/communities.slice';
import { useAppDispatch } from 'src/redux/store';
import { useSelector } from 'react-redux';
import { EAppMode } from 'src/utils/appMode';
import vars from 'src/assets/styles/utils/vars.module.scss';
import { selectAppMode } from 'src/redux/application/application.selectors';

export const MyCommunities: React.FC<TMyCommunitiesProps> = () => {
  const { data, loading } = useListCommunityInfoQuery();
  const token = useSelector(selectTokenAuth);
  const dispatch = useAppDispatch();
  const communitiesList = useSelector(selectCommunitiesList);
  const [searchQuery, setSearchQuery] = useState('');
  const appMode = useSelector(selectAppMode);

  // useEffect(() => {
  //   if (data?.listCommunityInfo?.projects) {
  //     type TProjects = NonNullable<
  //       NonNullable<ListCommunityInfoQuery['listCommunityInfo']>['projects']
  //     >;
  //     const items = data.listCommunityInfo.projects.reduce((acc: TProjects, item) => {
  //       let include = false;
  //       const projectHasLocation = item?.latitude && item.longitude;
  //       const configHasLocation =
  //         item?.configurations &&
  //         item.configurations[0] &&
  //         item.configurations[0].latitude &&
  //         item.configurations[0].longitude;

  //       if (item?.configurations?.length && (projectHasLocation || configHasLocation)) {
  //         if (token?.username === item?.user) {
  //           include = true;
  //         }
  //       }

  //       if (include) {
  //         acc.push({
  //           ...item,
  //           configurations:
  //             item?.configurations && item.configurations[0] ? [item.configurations[0]] : [],
  //         });
  //       }

  //       return acc;
  //     }, []);

  //     items.sort((a, b) => +new Date(b?.timestamp) - +new Date(a?.timestamp));
  //     dispatch(setCommunitiesList(items));
  //   }
  // }, [data, dispatch, token?.username]);

  const handleGoClicked = () => {
    // handling goes here TODO remove console.log later
  };

  return (
    <LoadingWrapper loading={loading}>
      {() => (
        <div className={s.container}>
          {appMode === EAppMode.Mobile ? (
            <BaseSearch
              name="communitiesSearch"
              theme="filled-gray"
              value={searchQuery}
              onChange={({ value }) => setSearchQuery(value)}
              label="Search by name"
              iconRight="search"
              iconRightColor={vars['color-black']}
            />
          ) : (
            <LocationSearch
              dropdownClassName={s.locationSearch}
              name="location"
              theme="filled-gray"
              flyAfterSelect
            />
          )}
          <BaseBanner
            iconStart={'atom'}
            textHeading="Bring your simulations closer to reality"
            text="Connects assets, use realtime data and trade"
            cta={{ label: 'Go', handler: handleGoClicked }}
          />
          <MapSidebarList
            mobileListClassName={s.list}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </div>
      )}
    </LoadingWrapper>
  );
};
